import styled from '@emotion/styled';

const StyledContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'selectedItem' && prop !== 'isChildren',
})<{
  selectedItem: boolean;
  isChildren: boolean;
}>`
  display: flex;
  width: 100%;
  font-size: 16px;
  font-weight: ${({ isChildren }) => (isChildren ? 400 : 500)};
  max-height: 32px;
  padding: 4px 8px;
  justify-content: space-between;
  border-radius: 4px;
  align-items: center;
  background-color: ${({ selectedItem }) =>
    selectedItem ? 'rgba(0, 102, 204, 0.1)' : undefined};
  color: ${({ selectedItem, isChildren }) =>
    selectedItem ? 'var(--dk-accent, #06C)' : isChildren ? 'var(--dk-text-secondary, #888D96)' : 'var(--dk-text-primary, #34383d)'};
  margin-top: ${({ isChildren }) => (isChildren ? '' : '12px')};
  white-space: pre;
  cursor: pointer;
  &:hover {
    background-color: ${({ selectedItem }) => (selectedItem ? '' : 'var(--dk-bg-muted, #f3f5f6)')};
  }
  &:active {
    background-color: rgba(0, 102, 204, 0.1);
    color: var(--dk-text, black);
  }
`;

const StyledTitle = styled.div`
  line-height: 24px; /* 150% */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: break-all;
  display: flex;
  align-items: center;
`;

const ArrowLayout = styled.div<{ open: boolean; selectedItem: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  transform: ${({ open }) => (open ? 'rotate(0deg)' : 'rotate(-180deg)')};
  transition: transform 0.1s ease-in-out;
  color: ${({ selectedItem }) => (selectedItem ? 'var(--dk-accent, #0066CC)' : '')};
`;

const IndicatorWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 32px;
  min-width: 32px;
  height: 32px;
  justify-content: center;
`;

const Indicator = styled.div<{ selectedItem: boolean }>`
  width: 1px;
  height: 100%;
  background: ${({ selectedItem }) => (selectedItem ? 'var(--dk-accent-tint, #C2DAF3)' : 'var(--dk-bg-strong, #E7E9EC)')};

  .category-content-container:active & {
    background: var(--dk-accent-tint, #c2daf3);
  }
`;

export {
  StyledTitle,
  StyledContainer,
  ArrowLayout,
  IndicatorWrapper,
  Indicator,
};
